



































































import { Component, Vue } from "vue-property-decorator";
import { StpCookieBannerOption } from "./interfaces/interfaces";
import CookieBannerWrapper from "./components/CookieBannerWrapper.vue";
import CookieBannerBody from "./components/CookieBannerBody.vue";
import CookieBannerContainer from "./components/CookieBannerContainer.vue";
import CookieBannerFooter from "./components/CookieBannerFooter.vue";
import CookieBannerButton from "./components/CookieBannerButton.vue";
import CookieBannerOptionsList from "./components/CookieBannerOptionsList.vue";
import CookieBannerOption from "./components/CookieBannerOption.vue";
import CookieBannerHeadline from "./components/CookieBannerHeadline.vue";
// @ts-ignore
import { ThemeProvider } from "vue-styled-components";

const LOCAL_STORAGE_KEY = "stp_cookie_banner";

@Component({
  components: {
    ThemeProvider,
    CookieBannerWrapper,
    CookieBannerBody,
    CookieBannerContainer,
    CookieBannerFooter,
    CookieBannerButton,
    CookieBannerOptionsList,
    CookieBannerOption,
    CookieBannerHeadline,
  },
  props: {
    primaryColor: String,
    headline: String,
    bodyText: String,
    advancedBodyText: String,
    acceptButtonLabel: String,
    declineButtonLabel: String,
    advancedAcceptButtonLabel: String,
    availableOptions: Array,
    theme: Object,
  },
})
export default class CookieBanner extends Vue {
  showAdvanced: boolean = false;

  results: { [key: string]: any } = {};

  mounted() {
    const options = this.getAcceptedOptions();
    if (options) {
      this.triggerAcceptEvent(options);
    } else {
      this.show();
    }
  }

  show() {
    this.reset();
    this.$modal.show("cookie-banner");
  }

  close() {
    this.$modal.hide("cookie-banner");
  }

  acceptAll() {
    const options = this.$props.availableOptions.map(
      (option: StpCookieBannerOption) => option.name
    );
    this.accept(options);
  }

  acceptSelected() {
    const options: string[] = [];
    this.$props.availableOptions.forEach((option: StpCookieBannerOption) => {
      if (this.results[option.name]) {
        options.push(option.name);
      }
    });
    this.accept(options);
  }

  accept(options: string[]) {
    this.saveAcceptedOptions(options);
    this.triggerAcceptEvent(options);
    this.close();
  }

  triggerAcceptEvent(options: string[]) {
    const event = new CustomEvent("cookie-banner", {
      detail: { acceptedOptions: options },
    });
    window.dispatchEvent(event);
  }

  decline() {
    this.showAdvanced = true;
  }

  reset() {
    this.$props.availableOptions.forEach((option: StpCookieBannerOption) => {
      this.results[option.name] = option.default || false;
    });

    this.showAdvanced = false;
  }

  get computedTheme() {
    return {
      primaryColor: "#76b830",
      activeCheckboxColor: "#ffaa0f",
      uncheckedCheckboxColor: "rgb(150, 150, 150)",
      acceptButtonColor: "#76b830",
      declineButtonColor: "#ccc",
      advancedAcceptButtonColor: "#ccc",
      checkboxSize: "20px",
      // @ts-ignore
      ...this.theme,
    };
  }

  private saveAcceptedOptions(options: string[]) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(options));
  }

  private getAcceptedOptions() {
    const options = localStorage.getItem(LOCAL_STORAGE_KEY);
    return options ? JSON.parse(options) : null;
  }
}
